export const addSnippetTooltipdisabled =
  'Unable to add this snippet to the Block Diagram. Fill workshop name first.'
export const addSnippetTooltipenabled = 'Add this snippet to the Block Diagram'
export const description =
  'Enter snippet name and a parent snippet or choose to create new root section. This way you can create a block diagram from the snippets. After you click Generate Output, each snippet will be converted into a separate presentation page. The pages will be added  in the same order as in the Block Diagram. '
export const modalHeading = 'Adding snippet to the diagram'
export const validationStatment =
  'Unable to add a snippet. Please enter snippet name and select parent'
